// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media print{@page{size:auto}body{zoom:50%}body,html{height:auto!important;-webkit-print-color-adjust:exact}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
